<template>
  <div class="container">
    <div class="header">
      <h1 align="center" style="font-size: xx-large">研究人员问卷调查<br/>
        Researcher’s Background Questions
      </h1>
      <h3 style="font-size: 20px; width: 700px; margin-left: auto;margin-right: auto ;margin-bottom: auto ">
      我们承诺不会将您提供的可以识别身份的个人信息公开。您的信息将加密保存在后台数据中
      供我们对TALL的使用情况进行统计调查。<br/>
        <br/>
      We promise not to disclose the personally identifiable information you provide.
      Your information will be encrypted and stored in back-end data for our statistical
      investigation of TALL's usage. <br/>
        <br/>


      </h3>
    </div>

    <div class="content" style="margin-top: 150px">
      <div class="left"></div>
      <div class="center">
        <div>



          <el-form :model="content" ref="numberValidateForm">
            <div>
              <!-- 身份选择-->
              <div class="el-row" >
                <p style="font-size: 24px">  * 个人情况 （请选择所有符合的选项）： （必填）<br/>
                  About you - (please tick all that apply): <font color="red">(Obligatory)</font>
                </p>
                <el-form-item size="large"
                              prop="identity"
                              :rules="[{ required: true, message: '请选择身份', trigger: 'blur' },]">
                  <el-cascader
                        :options="options1"
                        :show-all-levels="false"
                        @change="handleChange"
                        placeholder="请选择身份"
                        v-model="content.identity"
                        style="width: 350px"
                  >
                  </el-cascader>
                </el-form-item>
              </div>
              <!-- 国家选择-->
              <div  class="el-row">
                <p style="font-size: 24px; justify-content: center">  * 国家/地区： （必填）<br/>
                  Country/region:  <font color="red">(Obligatory)</font>
                </p>
                <el-form-item prop="country"
                              :rules="[{ required: true, message: '请填写国家'},
                              {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }]">
                  <el-input v-model="content.country" placeholder="请填写国家" style="width: 350px
                  ;margin-top: 35px; margin-left: 10px"></el-input>
                </el-form-item>
              </div>
              <!-- 学校选择-->
              <div  class="el-row">
                <p style="font-size: 24px">  * 学校：（必填）<br/>
                  Institution:  <font color="red">(Obligatory)</font>
                </p>

                <el-form-item prop="school"
                              :rules="[{ required: true, message: '请填写学校'},
                              {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }]">
                  <el-input v-model="content.school" placeholder="请填写学校" style="width: 350px
                  ;margin-top: 35px; margin-left: 10px"></el-input>
                </el-form-item>

              </div>
            </div>
            <div class="yesbutton">
              <el-button type="primary" @click="submitForm('numberValidateForm')">提交<br/>
                Submit
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="footer"></div>
  </div>
</template>
<script>
import GLOBAL from "../plugins/global_variable";
export default {
  name: "Questionnaire",
  data() {
    return {
      user: {
        email: '',
        pwd:'',
      },
      options1: [{
        value: '0',
        label: '学生 Student ',
        children: [
          {
            value: '01',
            label: '本科生 Undergraduate'
          },
          {
            value: '02',
            label: '硕士生 Masters',
          },
          {
            value: '03',
            label: '博士生 PhD',
          },
          {
            value: '04',
            label: '其它 Other',
          },
        ]
      }
      , {
        value: '1',
        label: '语言教师（任何层次）Language teacher/instructor (any level)'
      }
      ,{
        value: '2',
        label: '教师教育者  Teacher educator'
      }
      ,{
        value: '3',
        label: '大学学术人员 University academic',
          children: [
            {
              value: '31',
              label: ' 初级 Early career'
            },
            {
              value: '32',
              label: '中级 Mid-career',
            },
            {
              value: '33',
              label: ' 高级 Established scholar',
            }
          ]
        }],

      content: {
        email:GLOBAL.Reemail,
        pwd:GLOBAL.password,
        identity: '',
        country:'',
        school:'',
        activate_code:'',
      },

    }
  },

  methods: {
    handleChange(value) {
      console.log(value);
      var n = value.length
      console.log(n)
      var identity_key = value[n-1]
      console.log(identity_key)
      this.content.identity = identity_key

    },

    submitForm(formName) {

      console.log(this.content)
      var _this = this;
      //各个问卷调查格式都正确
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.content);
          this.$confirm('确定问卷填写无误?'+'Please check if you have answer all the questions.', 'Notice', {
            confirmButtonText: 'confirm',
            cancelButtonText: 'cancel',
            type: 'warning'
          }).then(() => {
            //赋值给全局变量
            console.log('ns')
            GLOBAL.content=this.content;
            console.log(GLOBAL.content)

            var _this = this;
            axios.post('researcher/register', GLOBAL.content).then(
                function (resp) {
                  if (resp.data != null) {

                    _this.$message({
                      message: '问卷填写成功，成功注册！You have successfully ' +
                          'signed up. Please check your email and activate your account.\n',
                      type: 'success',

                    });

                    GLOBAL.email=resp.data.email;
                    _this.$router.push('/ResearcherLogin');

                  }



                });




          }).catch(() => {
            _this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }
      });
    },
  },
  created() {//生命周期函数
    document.body.style.backgroundColor="#DCDCDC";
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });

  }
}
</script>

<style scoped>
.row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom:20px
}
.el-row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin-bottom:20px
}
.yesbutton{
  display: flex;
  justify-content: center;
  margin-bottom:80px
}
.container{
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.header{
  display: flex;
  flex-direction: column;
  height: 40vh;
}
.footer{
  height: 75px;
}
.content{
  display: flex;
  flex-direction: row;
  flex: 1;
}
.el-row{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom:80px
}
.left,.right{
  width:200px;
}
.center{
  flex: 1;
}
.normal{
  font-size:22px;
  font-weight: normal;
}
/*.el-form-item>>>{*/
/*  font-size:22px;*/
/*}*/

.el-form-item >>> label{
  font-size: 22px;
}

.el-select >>>{
  font-size: 22px;
}








</style>
